export default __webpack_public_path__ + "assets/images/avatar.b30fa3.webp";